import cx from 'classnames';
import { createBrowserHistory } from 'history';
import moment from 'moment';
import React, { useEffect } from 'react';
import Geocode from 'react-geocode';
import { useSelector } from 'react-redux';
import { useResizeDetector } from 'react-resize-detector';
import { BrowserRouter } from 'react-router-dom';
import { setDefaultLanguage, setLanguage, setTranslations, translate } from 'react-switch-lang';
import { ToastContainer } from 'react-toastify';
import Auth0Provider from 'src/auth/Auth0Provider';
import InvestorApp from 'src/investorSystem/App';
import en from 'src/lang/en.json';
import heb from 'src/lang/heb.json';
import { RootState } from 'src/redux/config/rootReducer';
import { loadIcons } from 'src/utils/functions/loadIcons';

const toasterContainerStyle = {
  zIndex: 1999,
};

const EN = 'en';

const dict = {
  investor: () => <InvestorApp />,
};

const basenameDict = {
  investor: 'dashboard',
  operator: 'operator',
};

const MainConfigurations = () => {
  const {
    colorScheme,
    enableFixedHeader,
    enableFixedSidebar,
    enableFixedFooter,
    closedSmallerSidebar,
    enableMobileMenu,
    enablePageTabsAlt,
  } = useSelector((state: RootState) => state.oldTheme);

  const { width } = useResizeDetector({
    handleHeight: false,
    refreshMode: 'debounce',
    refreshRate: 1000,
  });

  useEffect(() => {
    // loads all icons that were imported
    loadIcons();

    //initalize translation languages
    moment.locale('en');
    setTranslations({ en, heb });
    setDefaultLanguage(EN);
    setLanguage(EN);
    Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAP_API_KEY);
  }, []);

  const history = createBrowserHistory({});

  const path = (/#(\/.*)$/.exec(history.location.hash) || [])[1];
  if (path) {
    history.replace(path);
  }

  return (
    <>
      <Auth0Provider history={history}>
        <div
          className={cx(
            'app-container app-theme-' + colorScheme,
            { 'fixed-header': enableFixedHeader },
            { 'fixed-sidebar': enableFixedSidebar || width < 1250 },
            { 'fixed-footer': enableFixedFooter },
            // { "closed-sidebar": enableClosedSidebar || width < 1250 },
            {
              'closed-sidebar-mobile': closedSmallerSidebar || width < 1250,
            },
            { 'sidebar-mobile-open': enableMobileMenu },
            { 'body-tabs-shadow-btn': enablePageTabsAlt },
          )}
        >
          <BrowserRouter basename={basenameDict[process.env.REACT_APP_TYPE]}>
            {dict[process.env.REACT_APP_TYPE]()}
          </BrowserRouter>
        </div>
      </Auth0Provider>
      <ToastContainer position="top-right" autoClose={5000} style={toasterContainerStyle} />
    </>
  );
};

export default translate(MainConfigurations);
